import type { ReactNode } from 'react';
import { use } from 'react';
import { createPortal } from 'react-dom';

import { ToolChromeContext } from './ToolChromeContext.ts';

export interface ToolAsideProps {
  children: ReactNode;
}

/**
 * Escape hatch out of the bezel: portals its children to the target
 * `ToolDisplay` renders immediately after the chrome grid, so a status
 * renderer can surface UI outside the tool chrome (e.g. follow-up
 * suggestion buttons) while staying a single render expression.
 */
export function ToolAside({ children }: ToolAsideProps) {
  const { asideElement } = use(ToolChromeContext);
  if (asideElement === null) {
    return null;
  }
  return createPortal(children, asideElement);
}
